module.exports = __webpack_public_path__ + "img/horizontal_4_2_pp2_2.75364611.png";